



// 



import { Component, OnInit } from '@angular/core';
import { fadeInOut } from '../../services/animations';
import { Member } from '../../models/member.model';
import { ApiService } from '../../services/api.service';
import { MatDialog } from '@angular/material';
import { AlertService, DialogType, MessageSeverity } from '../../services/alert.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { User } from '../../models/user.model';
import { Subject } from 'rxjs';
import { MemberAccess } from '../../models/member-access.model';
import { MemberAccessActionType } from '../../models/enums';

@Component({
    selector: 'member-logs',
    template: require('./member-logs.component.html'),
    styles: [require('./member-logs.component.css')],
    animations: [fadeInOut]
})
export class MemberLogsComponent implements OnInit {
    logs = [];
    totalLogs = 0;
    page = 1;
    pageSize = 10;
    memberId: string = '';
    email: string = '';

    constructor(private logService: ApiService, private activatedRoute: ActivatedRoute) {
        if (!!this.activatedRoute.snapshot.params["memberId"]) {
            this.memberId = this.activatedRoute.snapshot.params["memberId"];
        }
       
    }

    ngOnInit() {
        this.loadLogs();
    }

    loadLogs() {
        this.logService.getLogs(this.memberId, this.email, this.page, this.pageSize).subscribe(response => {
            this.logs = response.logs;
            this.totalLogs = response.totalLogs;
        });
    }

    onPageChange(event) {
        this.page = event.pageIndex + 1;
        this.pageSize = event.pageSize;
        this.loadLogs();
    }

    onFilterChange() {
        this.page = 1; // Reset to first page
        this.loadLogs();
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/member-logs/member-logs.component.ts